<template>
  <v-bottom-navigation
    dark
    app
    grow
    class="background elevation-0"
    active-class="primary text--white"
  >
    <template>
      <v-btn v-for="item in elements" :key="item.title" :to="item.route">
        <span>{{ item.title }}</span>
        <v-icon>{{ item.icon }}</v-icon>
      </v-btn>
    </template>
  </v-bottom-navigation>
</template>

<script>
export default {
  props: {
    elements: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
